import { type z } from "zod"
import { type GasEligibilityResultSchema } from "@/features/meter-points/schemas/checkMeterPointsEligibilitySchema"
import { ONBOARDING_DEFAULT_FORM_VALUES } from "@/features/onboarding/wizard"

export function parseGasMeterPointEligibility(
    meterPointEligibility: z.infer<typeof GasEligibilityResultSchema>
) {
    const { supplyPoint } = meterPointEligibility
    const { meterPoint } = supplyPoint
    const { address } = meterPoint

    return {
        billingAddress: address,
        gas: {
            ...ONBOARDING_DEFAULT_FORM_VALUES.gas,
            supplyPoint: {
                id: supplyPoint.id,
                isEligible: meterPointEligibility.isEligible,
                meterPoint: {
                    id: meterPoint.id,
                    address,
                    isSmartMeter: meterPoint.isSmartMeter,
                    priceLevel: meterPoint.priceLevel,
                    poweredStatus: meterPoint.poweredStatus,
                },
            },
        },
    }
}
